<template>
  <div class="abc-search-field d-flex align-center">
    <label class="stat-filter-col__label">поиск:</label>
    <v-text-field
      :value="value"
      style="border-radius: 10px;"
      append-icon="mdi-magnify"
      placeholder="Блюдо или категория"
      background-color="#fff"
      hide-details
      flat
      solo
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
  export default {
    name: 'AbcSearchField',
    props: {
      value: {
        type: String,
        default: '',
      },
    },
  }
</script>

<style lang="less" scoped>
.abc-search-field {
  // ширина фиксирована, но поле сжимается, когда фильтрам тесно в ряд
  width: 280px;
  max-width: 100%;

  // когда в слоте фильтров есть сосед - отделяемся от него, как соседние колонки
  &:not(:first-child) {
    margin-left: 15px;

    .media-sm({
      margin-left: 0;
      // как зазор между соседними колонками фильтров на мобиле
      margin-top: 16px;
    });
  }

  .media-sm({
    width: 100%;
  });

  // solo-поле по умолчанию 20px — приводим к размеру соседних фильтров
  ::v-deep input {
    font-size: 14px;
  }
}
</style>
